"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerItemsInSubjectOfArrays = void 0;
var Registration_1 = require("./Registration");
/**
 * Push item into array of RxJS subjects and return object representing this pushment that can be destroyed
 * @param base will automatically triggers next in given subject and when unregistered triggers another one
 * @param add is array of items which will be added into base
 */
function registerItemsInSubjectOfArrays(_a) {
    var currentValue = _a.currentValue, base = _a.base, add = _a.add, compare = _a.compare, errorReporting = _a.errorReporting;
    var errorReportingFunction = errorReporting ||
        (function (error) {
            throw error;
        });
    var baseFrameLast = currentValue;
    var subscription = base.subscribe(function (baseFrameCurrent) {
        baseFrameLast = baseFrameCurrent;
    });
    base.next(__spreadArray(__spreadArray([], currentValue), add));
    return new Registration_1.Registration(function () {
        subscription.unsubscribe();
        if (baseFrameLast === null) {
            return;
        }
        baseFrameLast = __spreadArray([], baseFrameLast);
        var _loop_1 = function (item) {
            var index = baseFrameLast.findIndex(function (item2) { return (compare || (function (a, b) { return a === b; }))(item, item2); });
            if (index === -1) {
                console.info({ base: base, baseFrameLast: baseFrameLast, item: item });
                errorReportingFunction(Error("Item was not found in last item of subject of arrays. Into subject was probbably pushed next by non-compatible sources."));
            }
            baseFrameLast.splice(index, 1);
        };
        for (var _i = 0, add_1 = add; _i < add_1.length; _i++) {
            var item = add_1[_i];
            _loop_1(item);
        }
        base.next(baseFrameLast);
    });
}
exports.registerItemsInSubjectOfArrays = registerItemsInSubjectOfArrays;
//# sourceMappingURL=registerItemsInSubjectOfArrays.js.map